import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderBtn,
  SliderDots,
  SliderCount,
} from '@studiometa/ui';

/**
 * Slider component
 */
export default class SliderReassurance extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderItem,
      SliderDrag,
      SliderDots,
      SliderBtn,
      SliderCount,
    },
    options: {
      currentFit: {
        type: String,
        default: 'oversize',
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    super.mounted();
    this.setActiveSlide();
  }

  /**
   *
   */
  setActiveSlide() {
    const items = this.$children.SliderItem;
    items.forEach((item, index) => {
      item.$el.classList.remove('is-active');
      const isActive = item.$el.textContent.includes(this.$options.currentFit);
      console.log(isActive);
      if (isActive) {
        item.$el.classList.add('is-active');
        this.goTo(index);
      }
    });
  }
}
